<template>
  <div>
    <logged-in-header />
    <product-change-logs-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import productChangeLogsPanel from "../components/product-change-logs/ProductChangeLogsPanel";

export default {
  components: { loggedInHeader, productChangeLogsPanel }
};
</script>
